<template>
  <div class="contact-category-list">
    <div class="search-bar-component">
      <b-row class="mb-1 mb-md-2">
        <b-col cols="12">
          <b-input-group size="lg" class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input v-model="searchQuery" placeholder="Sök artikel..." />
          </b-input-group>
        </b-col>
      </b-row>
    </div>
    <b-row v-for="categoryID in articleCategories" :key="categoryID">
      <b-col v-if="categoryID > 0" cols="12">
        <div
          v-if="
            filteredArticles.find((art) => art.categories.includes(categoryID))
          "
          :class="'contact-group contact-group-' + categoryID"
        >
          <b-button
            v-b-toggle="'collapse-' + categoryID"
            variant="flat"
            class="border-bottom mb-1"
            block
          >
            <h4 class="mb-0">
              {{ getArticleCategory(categoryID).title }}
              <span class="text-primary">
                <i class="fas fa-caret-down"></i>
              </span>
            </h4>
          </b-button>
          <b-collapse visible :id="'collapse-' + categoryID">
            <div class="ce-contact-list">
              <div v-for="article in filteredArticles" :key="article.id">
                <template
                  v-if="article.categories.find((catId) => catId == categoryID)"
                >
                  <b-card
                    class="ce-contact-list-item"
                    :class="{
                      selected: selectedArticles.find(
                        (at) => at === article.id
                      ),
                    }"
                    @click="emitSelectedArticles(article)"
                    no-body
                  >
                    <div class="card-body">
                      <b-row>
                        <b-col cols="12" class="ce-contact-info">
                          <!--
                                                        Artikel bild kan läggas in här om den ska in före titeln
                                                        article.feature_image
                                                     -->
                          <div class="ce-contact-description">
                            <h6 class="mb-0">{{ article.title }}</h6>
                            <!-- <p><small><span v-if="article.description">{{ article.description }}</span></small></p> -->
                          </div>

                          <div class="icon icon-add">
                            <span class="text-primary"
                              ><i class="fas fa-square"></i
                            ></span>
                          </div>
                          <div class="icon icon-checked">
                            <span class="text-success"
                              ><i class="fas fa-check-square"></i
                            ></span>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card>
                </template>
                <template v-else></template>
              </div>
            </div>
          </b-collapse>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BCard,
  BButton,
  BCollapse,
} from "bootstrap-vue";
import { mapGetters } from "vuex";

export default {
  name: "SelectArticles",
  components: {
    BRow,
    BCol,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BCard,
    BButton,
    BCollapse,
  },
  props: {
    currentArticles: {
      default: function() {
        return [];
      },
      type: Array,
    },
  },
  mounted() {
    this.selectedArticles = [...this.currentArticles] ?? [];
    this.oldArticles = [...this.currentArticles] ?? [];
  },
  data() {
    return {
      searchQuery: "",
      selectedArticles: [],
      oldArticles: [],
    };
  },
  computed: {
    ...mapGetters({ articles: "getAllArticles" }),
    ...mapGetters(["getArticleCategoryById"]),
    justArticles: function() {
      return this.articles.filter((a) => !a.is_news_article && !a.is_about_me);
    },
    articleCategories: function() {
      return this.getFilteredArticleCategories();
    },
    filteredArticles: function() {
      return this.justArticles.filter((article) => {
        return (
          (article.title
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase()) ||
            article.tags.find((tag) =>
              tag.toLowerCase().includes(this.searchQuery)
            )) &&
          article.published === true
        );
      });
    },
  },
  methods: {
    getArticleCategory(categoryID) {
      return this.getArticleCategoryById(categoryID);
    },
    getFilteredArticleCategories() {
      if (!this.justArticles) return;

      let filtered = [];
      for (let i = 0; i < this.justArticles.length; i++) {
        for (let j = 0; j < this.justArticles[i].categories.length; j++) {
          const catId = filtered.find(
            (cat) => cat === this.justArticles[i].categories[j]
          );
          if (filtered.includes(catId) || catId <= 0) continue;

          filtered.push(this.justArticles[i].categories[j]);
        }
      }

      filtered = filtered.sort((a, b) => a.sort_order - b.sort_order);
      return filtered;
    },
    emitSelectedArticles: function(article) {
      this.selectedArticles.find((atId) => atId === article.id)
        ? this.selectedArticles.splice(
            this.selectedArticles.findIndex((atId) => atId === article.id),
            1
          )
        : this.selectedArticles.push(article.id);
      this.$emit("selectedArticlesUpdated", {
        newArticles: this.selectedArticles,
        oldArticles: this.oldArticles,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables/_variables.scss";
.contact-group > .btn {
  text-align: left;
  padding-left: 0;
  /* border: 0!important;
        background-color: #fff;
        box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%); */
}
.contact-group > .btn span {
  float: right;
}
.btn svg {
  transition: all 0.25s ease-in-out;
}
.btn.collapsed svg {
  transform: rotate(180deg);
}
.btn.not-collapsed svg {
  transform: rotate(0deg);
}
.card {
  margin-bottom: 1rem;
}
.ce-contact-list-item:hover {
  cursor: pointer;
}
.ce-contact-info {
  display: flex;
  align-items: center;
}
.ce-contact-avatar {
  padding-right: 1rem;
}
.ce-contact-description {
  padding-right: 0.5rem;
  margin-right: auto;
}
.ce-contact-info .icon {
  font-size: 1.5rem;
  padding-right: 0.75rem;
}
.icon-checked {
  display: none;
}
.selected .icon-add {
  display: none;
}
.selected .icon-checked {
  display: block;
}
</style>
